import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=6070a4cc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=6070a4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6070a4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6070a4cc')) {
      api.createRecord('6070a4cc', component.options)
    } else {
      api.reload('6070a4cc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=6070a4cc&scoped=true&", function () {
      api.rerender('6070a4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P6LHsqC8cy9Y/JS/comp/DateRangeExt.vue"
export default component.exports